<script lang="ts" setup>
import ReportProblemForm from "./Form.client.vue";
import { type ReportedFeedbackSource } from "~/types/ReportedFeedback";

const props = defineProps({
  isConsolidated: {
    type: Boolean,
    default: false,
  },
  source: {
    type: String as () => ReportedFeedbackSource,
    default: "gradebook",
  },
  showUrgency: {
    type: Boolean,
    default: true,
  },
  showEmail: {
    type: Boolean,
    default: false,
  },
  variant: {
    type: String as () => "text" | "icon",
    default: "text",
  },
  iconSize: {
    type: Number,
    default: 32,
  },
});

const showReportProblemModal = () => {
  const { open, close } = useDialog({
    title: "Report Issue",
    component: ReportProblemForm,
    props: {
      source: props.source,
      showUrgency: props.showUrgency,
      showEmail: props.showEmail,
      onClose: () => {
        close();
      },
    },
  });

  open();
};
</script>

<template>
  <button
    v-if="props.variant == 'icon'"
    type="button"
    aria-label="Report Issue"
    @click="showReportProblemModal"
  >
    <BaseIconButton tooltip="Report Issue" color="danger" :size="iconSize">
      <icon name="material-symbols:flag" :size="Math.round(iconSize * 0.65)" />
    </BaseIconButton>
  </button>
  <BaseTextButton
    v-else
    v-tooltip="'Report Issue'"
    color="danger"
    @click="showReportProblemModal"
  >
    <icon name="material-symbols:flag" size="25" />
  </BaseTextButton>
</template>

<style scoped></style>
